module.exports = __webpack_public_path__ + "src/assets/img/vanguarder-trailer.79f4589c.svg";